module.exports = __webpack_public_path__ + "img/sec5_3.2d7d4058.jpg";